import React, { useContext, useEffect, useState } from 'react';
import './copieDonnees.css';
import AppelerApi from '../../../services/appeler-api.service';
import { Box, Button, Checkbox, Modal, TextField } from '@mui/material';
import ChoisirIcone from '@mui/icons-material/Input';
import DestinationIcone from '@mui/icons-material/FastForward';
import CopierIcone from '@mui/icons-material/ContentCopy';
import debounce from 'lodash.debounce';
import { baseSelectionneeContext } from '../../../App';

const CopieDonnees = () => {

    const { baseSelectionnee } = useContext(baseSelectionneeContext);
    const [valeurEntree, _] = useState('');
    let [clients, setClients] = useState([]);
    let [source, selectionnerSource] = useState('');
    let [destination, selectionnerDestination] = useState('');
    let [donneesACopier, setDonneesACopier] = useState({prestations: false, clients: false});
    let [rienSelectionne, setRienSelectionne] = useState(true);
    let [messageOuvert, ouvrirMessage] = useState(false);
    let [message, setMessage] = useState('');
    let [copieEnCours, setCopieEnCours] = useState(false);

    const rechercheParChaine = debounce(chaine => {
        chercherSalon(chaine);
    }, 500);

    const selectionnerDonnees = donnees => {
        const nouvelleDonnee = {};
        nouvelleDonnee[donnees] = !donneesACopier[donnees];

        const nouvelleValeur = { ...donneesACopier, ...nouvelleDonnee };
        setDonneesACopier(nouvelleValeur);
        let quelqueChoseSelectionne = false;
        for (const valeur of Object.values(nouvelleValeur)) {
            quelqueChoseSelectionne = quelqueChoseSelectionne || valeur;
        }
        setRienSelectionne(!quelqueChoseSelectionne);
    };

    const copierDonnees = () => {
        if (copieEnCours) {
            return;
        }
        setCopieEnCours(true);
        AppelerApi.post('/copier-donnees', { source, destination, donneesACopier }).then(res => {
            if (res.erreur) {
                setMessage('Opération échouée, contacter le service technique');
                ouvrirMessage(true);
                setCopieEnCours(false);
            } else {
                setMessage('Opération réussie');
                ouvrirMessage(true);
                setCopieEnCours(false);
            }
        }, () => {
            setMessage('Opération échouée, contacter le service technique');
            ouvrirMessage(true);
            setCopieEnCours(false);
        });
    };

    const chercherSalon = (valeurFiltre) => {
        if (!valeurFiltre || valeurFiltre.length < 2) {
            return;
        }
        AppelerApi.get('/lire-clients-par-enseigne', { enseigne: valeurFiltre }).then(data => {
            setClients(data.clients);
        });
    };

    useEffect(() => {
    }, [valeurEntree, baseSelectionnee]);
    return (
        <div className="conteneur">
            <h1>Données client</h1>
            <div className="page">
                <div className="bloc-recherche">
                    <div className="recherche-salon">
                        <h3>Recherche</h3>
                        <TextField onChange={event => rechercheParChaine(event.target.value)} className="saisie-une-ligne"/>
                    </div>
                    {
                    (<div className="tableau-salon"><table>
                        <thead>
                            <tr>
                                <th scope="col">Salon</th>
                                <th scope="col">Source</th>
                                <th scope="col">Destination</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(clients).map(([index, client]) =>
                                <tr key={client.ID_Enseigne} className="ligne-activation">
                                    <td>{client.ID_Enseigne}</td>
                                    <td><ChoisirIcone className="icone" onClick={_ => selectionnerSource(client.ID_Enseigne)}/></td>
                                    <td><DestinationIcone className="icone" onClick={_ => selectionnerDestination(client.ID_Enseigne)}/></td>
                                </tr>
                            )}
                        </tbody>
                    </table></div>)
                    }
                </div>
                <div className="bloc-copie">
                    <h2>Données à copier</h2>
                    <div className="">
                        <Checkbox checked={donneesACopier.clients} onChange={() => selectionnerDonnees('clients')}/> Clients
                        <Checkbox checked={donneesACopier.prestations} onChange={() => selectionnerDonnees('prestations')}/> Prestations
                    </div>
                    {(source !== '' && destination !== '' &&
                        <p className={(rienSelectionne || copieEnCours) ? 'rien-selectionne' : ''}>Copier données de {source} à {destination} <CopierIcone className="icone" onClick={() => copierDonnees()}/></p>
                    )}
                    {(copieEnCours &&
                        <p className="copie-en-cours">Copie en cours...</p>
                    )}
                </div>
            </div>
            <Modal open={messageOuvert} onClose={() => ouvrirMessage(false)}>
                <Box className="pop-up">
                    <p>{message}</p>
                    <div className="boutons-pop-up">
                        <Button onClick={() => ouvrirMessage(false)}>Fermer</Button>
                    </div>
                </Box>
            </Modal>
        </div>
    );
};

export default CopieDonnees;